(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('[data-stop-dialog]');
    const popupReady = dialog && typeof dialog.showModal === 'function';
    const popupController = new AbortController();
    let stopTrigger;
    function positionBubble() {
      if (!dialog?.open || !stopTrigger) return;
      const rect = stopTrigger.getBoundingClientRect();
      const width = dialog.getBoundingClientRect().width;
      const height = dialog.getBoundingClientRect().height;
      const mobile = window.matchMedia('(max-width: 700px)').matches;
      const left = mobile ? 12 : Math.max(16, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 16));
      const above = !mobile && rect.bottom + height + 30 > window.innerHeight && rect.top - height - 14 >= 16;
      const top = mobile ? Math.max(12, window.innerHeight - height - 12) : Math.max(16, Math.min(above ? rect.top - height - 14 : rect.bottom + 14, window.innerHeight - height - 16));
      dialog.style.left = `${left}px`;
      dialog.style.top = `${top}px`;
      dialog.style.setProperty('--nr-arrow-left', `${Math.max(22, Math.min(rect.left + rect.width / 2 - left - 6, width - 34))}px`);
      dialog.toggleAttribute('data-above', above);
    }
    function openStop(summary) {
      const details = summary.parentElement;
      const content = details.querySelector('[data-stop-content]');
      if (!content) return;
      if (dialog.open) dialog.close();
      stopTrigger = summary;
      details.open = false;
      summary.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-stop-title]').textContent = summary.querySelector('span').textContent;
      const stage = summary.closest('[data-route-stage]');
      dialog.querySelector('[data-stop-stage]').textContent = stage ? stage.querySelector('h3').textContent : root.querySelector('h1').textContent;
      dialog.querySelector('[data-stop-body]').replaceChildren(...[...content.childNodes].map(node => node.cloneNode(true)));
      dialog.querySelector('[data-stop-body]').scrollTop = 0;
      dialog.showModal();
      positionBubble();
    }
    if (popupReady) {
      root.querySelectorAll('[data-stage-stop] > summary').forEach(summary => {
        summary.setAttribute('aria-haspopup', 'dialog');
        summary.setAttribute('aria-controls', dialog.id);
        summary.setAttribute('aria-expanded', 'false');
      });
      dialog.addEventListener('close', () => {
        stopTrigger?.setAttribute('aria-expanded', 'false');
        stopTrigger = undefined;
      }, { signal: popupController.signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, { signal: popupController.signal });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')].filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, { signal: popupController.signal });
      window.addEventListener('resize', positionBubble, { signal: popupController.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        if (dialog.open) dialog.close();
        popupController.abort();
      }, { signal: popupController.signal });
    }
    root.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('summary');
      if (!summary || !root.contains(summary) || summary.parentElement.tagName !== 'DETAILS') return;
      if (summary.parentElement.matches('[data-stage-stop]')) {
        if (popupReady) {
          event.preventDefault();
          event.stopPropagation();
          openStop(summary);
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      summary.parentElement.open = !summary.parentElement.open;
    }, true);
    const selects = [...root.querySelectorAll('[data-route-filter]')];
    const cards = [...root.querySelectorAll('[data-route-card]')];
    const counts = [...root.querySelectorAll('[data-route-count]')];
    const empty = root.querySelector('[data-route-empty]');
    const finder = root.querySelector('[data-route-finder]');
    const style = selects.find(select => select.dataset.routeFilter === 'style');
    const styleButtons = [...root.querySelectorAll('[data-route-style]')];
    const resultTitle = root.querySelector('#nrf-results-title');
    if (finder) {
      const params = new URLSearchParams(location.search);
      selects.forEach(select => { const value = params.get(select.name); if ([...select.options].some(option => option.value === value)) select.value = value; });
    }
    function filter(updateUrl = false) {
      let n = 0;
      cards.forEach(card => {
        const show = selects.every(select => select.value === 'all' || (card.dataset[select.dataset.routeFilter] || '').split(' ').includes(select.value));
        card.hidden = !show;
        if (show) n++;
      });
      counts.forEach(count => count.textContent = count.dataset.label.replace('[count]', String(n)));
      if (empty) empty.hidden = n !== 0;
      styleButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.routeStyle === style?.value)));
      if (finder && updateUrl) {
        const url = new URL(location.href);
        selects.forEach(select => { if (select.value === 'all') url.searchParams.delete(select.name); else url.searchParams.set(select.name, select.value); });
        history.replaceState(null, '', url);
      }
    }
    selects.forEach(select => select.addEventListener('change', () => filter(true)));
    styleButtons.forEach(button => button.addEventListener('click', () => { if (!style) return; style.value = button.dataset.routeStyle; filter(true); }));
    function resetFilters() { selects.forEach(select => select.value = 'all'); filter(true); }
    root.querySelectorAll('[data-route-reset]').forEach(button => button.addEventListener('click', resetFilters));
    finder?.addEventListener('reset', event => { event.preventDefault(); resetFilters(); });
    finder?.addEventListener('submit', event => {
      event.preventDefault(); filter(true);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelector('#nr-choose').scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
      resultTitle?.focus({ preventScroll: true });
    });
    if (cards.length) filter();
    const stages = [...root.querySelectorAll('[data-route-stage]')];
    const links = [...root.querySelectorAll('[data-stage-link]')];
    const progress = root.querySelector('[data-route-progress]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    links.forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
      target.querySelector('h3').focus({ preventScroll: true });
    }));
    if (stages.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const index = stages.indexOf(entry.target);
          links.forEach((link, i) => {
            if (i === index) link.setAttribute('aria-current', 'step');
            else link.removeAttribute('aria-current');
          });
          if (progress) progress.style.width = ((index + 1) / stages.length * 100) + '%';
        });
      }, { rootMargin: '-10% 0px -55% 0px', threshold: 0 });
      stages.forEach(stage => observer.observe(stage));
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); }, { once: true });
    }
  }
  document.querySelectorAll('[data-napton-routes]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-napton-routes]').forEach(init));
})();



